var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSupportForm = function SvgIconSupportForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.53 3.517a8.5 8.5 0 0 0-7.84 12.822.5.5 0 0 1 .051.392l-.885 3.106a.25.25 0 0 0 .063.244.25.25 0 0 0 .243.064l3.107-.886a.5.5 0 0 1 .392.05 8.5 8.5 0 1 0 4.87-15.792m-6.359.981a9.5 9.5 0 1 1 1.169 15.78l-2.905.828h-.002a1.248 1.248 0 0 1-1.54-1.54v-.001l.829-2.905a9.5 9.5 0 0 1 2.45-12.162",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.25 16.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.89 7.94A2 2 0 0 0 9.5 9.9a.5.5 0 0 1-1 0A3 3 0 1 1 12 12.86v.792a.5.5 0 1 1-1 0v-1a.77.77 0 0 1 .7-.76 2 2 0 0 0 .19-3.951",
    clipRule: "evenodd"
  })));
};
export default SvgIconSupportForm;